module.exports = __webpack_public_path__ + "static/media/orgRightArrow.8c9cc1ac.svg";